// extracted by mini-css-extract-plugin
export default {"header":"App_header__PFnSE","link":"App_link__W8z95","button":"App_button__c8lPl","subLink":"App_subLink__Odatz","dropdownFooter":"App_dropdownFooter__YPsa7"};